module.exports = "https://cdn.realtymogul.com/static/media/img_MRII.e8952d62.jpg";